import Nav from "@/components/portfolio/Nav";
import Hero from "@/components/portfolio/Hero";
import EditorialMarquee from "@/components/portfolio/Marquee";
import About from "@/components/portfolio/About";
import Services from "@/components/portfolio/Skills";
import Work from "@/components/portfolio/Work";
import Process from "@/components/portfolio/Process";
import Connect from "@/components/portfolio/Connect";
import Contact from "@/components/portfolio/Contact";
import Footer from "@/components/portfolio/Footer";

export default function Home() {
  return (
    <main data-testid="portfolio-home" className="relative bg-void text-zinc-100">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <About />
      <Services />
      <Work />
      <Process />
      <Connect />
      <Contact />
      <Footer />
    </main>
  );
}
